import request from '@/utils/request'
import store from '@/store'
import Config from '@/config'
import { getLogout } from '@/api/index'
import { removeToken } from '@/utils/auth'

/**
 * 通用js方法封装处理
 * Copyright (c) 2019 yawei
 */

const baseURL = process.env.VUE_APP_BASE_API

// 日期格式化
export function parseTime(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') {
			return ['日', '一', '二', '三', '四', '五', '六'][value]
		}
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

// 表单重置
export function resetForm(refName) {
	if (this.$refs[refName]) {
		this.$refs[refName].resetFields();
	}
}

// 添加日期范围
export function addDateRange(params, dateRange) {
	var search = params;
	search.beginTime = "";
	search.endTime = "";
	if (null != dateRange && '' != dateRange) {
		search.beginTime = this.dateRange[0];
		search.endTime = this.dateRange[1];
	}
	return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
	var actions = [];
	Object.keys(datas).map((key) => {
		if (datas[key].dictValue == ('' + value)) {
			actions.push(datas[key].dictLabel);
			return false;
		}
	})
	return actions.join('');
}

// 通用下载方法
export function download(fileName) {
	window.location.href = baseURL + "/web/common/download?fileName=" + encodeURI(fileName) + "&delete=" + true;
}

// 本地资源通用下载方法
export function resourceDownload(fileName) {
	window.location.href = baseURL + "/web/common/download/resource?name=" + encodeURI(fileName);
}
// 获取图片通用方法
export function getImgUrl(fileName) {
	return baseURL + "/web/common/download/resource?name=" + encodeURI(fileName);
}

// 统一退出登录：调用后端注销接口 -> 清空本地登录态 -> 跳转山东统一认证登录页
export function logout(recid) {
	let id = recid;
	if (!id) {
		// 未显式传入 recid 时，从本地登录态兜底取
		try {
			const session = JSON.parse(localStorage.getItem('ssessionLoginUser'));
			id = session && session.user && session.user.ywFwjgRecid;
		} catch (e) {
			id = undefined;
		}
	}
	const clearAndRedirect = () => {
		localStorage.clear();
		removeToken();
		window.location.href = Config.sdtyrzfwLoginUrl;
	};
	return getLogout(id).then(clearAndRedirect).catch(clearAndRedirect);
}

//富文本中img路径替换
export function replaceImgSrc(content) {
	let b = /<img [^>]*src=['"]([^'"]+)[^>]*>/g; // img 标签取src里面内容的正则
	let s = content.match(b); // 取到所有img标签 放到数组 s里面
	if (s != null) {
		for (let i = 0; i < s.length; i++) {
			let srcImg = s[i].replace(b, '$1'); //取src面的内容
			if (srcImg.indexOf('/profile/upload') != -1) {
				const repsrc = srcImg.replace('/profile', baseURL + "/common/download/resource?name=/profile");
				content = content.replace(srcImg, repsrc);
			}
		}
	}
	return content;
}

/**
 * 判断图片大小是否超出限制
 * @param fileSize 图片大小 单位：字节
 * @param limitSize 限制大小
 * @returns {{isExceed: boolean, limitSize: number}}
 */
export function isExceedLimitSize(fileSize, limitSize) {
	if (limitSize === 0) {
		return {
			limitSize: limitSize,
			isExceed: true
		}
	} else {
		let isExceed = fileSize / 1024 / 1024 > limitSize
		return {
			limitSize: limitSize,
			isExceed: isExceed
		}
	}
}

// 字符串格式化(%s )
export function sprintf(str) {
	var args = arguments,
		flag = true,
		i = 1;
	str = str.replace(/%s/g, function() {
		var arg = args[i++];
		if (typeof arg === 'undefined') {
			flag = false;
			return '';
		}
		return arg;
	});
	return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
	if (!str || str == "undefined" || str == "null") {
		return "";
	}
	return str;
}

// 随机生成32位字符串
export function randomString() {
	let len = 32
	let $chars =
		'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
	let maxPos = $chars.length
	let pwd = ''
	for (let i = 0; i < len; i++) {
		pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
	}
	return pwd
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
	id = id || 'id'
	parentId = parentId || 'parentId'
	children = children || 'children'
	rootId = rootId || 0
	//对源数据深度克隆
	const cloneData = JSON.parse(JSON.stringify(data))
	//循环所有项
	const treeData = cloneData.filter(father => {
		let branchArr = cloneData.filter(child => {
			//返回每一项的子级数组
			return father[id] === child[parentId]
		});
		branchArr.length > 0 ? father.children = branchArr : '';
		//返回第一层
		return father[parentId] === rootId;
	});
	return treeData != '' ? treeData : data;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTreeNoRootNode(data, id, parentId, children, rootId) {
	id = id || 'id'
	parentId = parentId || 'parentId'
	children = children || 'children'
	rootId = rootId || 0
	//对源数据深度克隆
	const cloneData = JSON.parse(JSON.stringify(data))
	//循环所有项
	const treeData = cloneData.filter(father => {
		let branchArr = cloneData.filter(child => {
			//返回每一项的子级数组
			return father[id] === child[parentId]
		});
		if (branchArr.length > 0) {
			father[children] = branchArr;
		}
		//返回第一层
		return father[parentId] === rootId;
	});
	return treeData.length > 0 ? treeData : data;
}

/**
 * 组织结构代码转名称
 * @param deptCode
 * @returns {string}
 */
export function selectDeptName(deptCode) {
	const globalDeptList = store.getters.deptList;
	let name = '';
	for (let dept of globalDeptList) {
		if (dept.deptCode == deptCode) {
			name = dept.shortName || dept.deptName;
			break;
		}
	}
	return name;
}

export function getJsonElementArray(list, key) {
	var obj = [];
	if (list instanceof Array) {
		for (var i in list) {
			var json = list[i];
			obj.push(json[key]);
		}
	}
	return obj;
}
/**
 * 下载文件
 * @param {Object} file
 */
export function handleDownload(file) {
	var name = file.fileName;
	var url = file.path;
	const a = document.createElement('a');
	a.setAttribute('download', name);
	a.setAttribute('target', '_blank');
	a.setAttribute('href', process.env.VUE_APP_BASE_API + url);
	a.click();
}


/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * 根据字典remark字段对应

 */
export function handleDictTree(data) {
	//对源数据深度克隆
	const cloneData = JSON.parse(JSON.stringify(data).replace(/dictName/g, 'label').replace(/dictValue/g, 'value'));
	//循环所有项
	const treeData = cloneData.filter(father => {
		let branchArr = cloneData.filter(child => {
			//返回每一项的子级数组
			return father.recid === child.precid
		});
		branchArr.length > 0 ? father.children = branchArr : '';
		//返回第一层
		return father.precid === '1';
	});
	return treeData != '' ? treeData : data;
}
/* 
*判断字符串是否为空 
*@param  s 字符串

*/
export function isEmptyStr(s) {
	if (s == null || s === '') {
		return true
	}
	return false
}
/* 
*日期比较
*适合格式（yyyy-mm-dd）
* 开始时间大于结束时间 返回true
*@param  startdata 开始日期
*@param  enddata 结束日期
*/

 export function dateCompare(startdata, enddata) {
            let arr = startdata.split("-");
            let starttime = new Date(arr[0], arr[1], arr[2]);
            let starttimes = starttime.getTime();
            let arrs = enddata.split("-");
            let lktime = new Date(arrs[0], arrs[1], arrs[2]);
            let lktimes = lktime.getTime();
            if (starttimes > lktimes) {
                return true;
            }
            else
                return false;
        }